import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { env } from '@/env';

/**
 * L'AVVISO dello Studio avatar: «Lo sfondo viene tolto: descrivi il personaggio, non il luogo» (ADR-0223 D4 resta com'e', Luca 14/10 «ADR-0227 (b)»: l'ADR-0227
 * e' respinto, ma l'incompatibilita' fra una scena nella richiesta e lo sfondo trasparente va resa VISIBILE all'utente).
 *
 * Sta vicino al campo della descrizione, SOLO quando lo sfondo scelto e' trasparente: chi lo monta decide con la sua condizione (`state.transparent` nell'editor
 * guidato, il fatto che la creazione manda sempre `transparent: true` in `AvatarCreate`). Con lo sfondo non trasparente non si disegna. Una chiave sola
 * (`avatars:common.backgroundRemoved`) in tutte le lingue del catalogo. Solo avviso: non blocca, non riscrive e non filtra la richiesta.
 *
 * 🔴 SOLO dove c'e' lo Studio (`VITE_FEATURE_AVATAR_STUDIO_ENABLED`, di solo staging, I-270): in produzione gli avatar sono accesi e lo Studio no, e un testo nuovo davanti
 * ai giocatori e' un cambio di comportamento che vuole un GO a parte (la scelta di Luca, 14/10, e' dell'avviso nello Studio; il mandato non dice «anche in prod»). DUE letture del flag,
 * come `RigaDiagnosi`: `env` (che i test accendono col mock) e il confronto LETTERALE, che il bundler piega — in produzione il corpo diventa `return null` e il marcatore
 * `avviso-sfondo-tolto` non e' in nessun file della build. Per estenderlo alla produzione basta togliere questa condizione: e' una riga.
 */
export function AvvisoSfondoTolto() {
  const { t } = useTranslation('avatars');
  if (!(env.featureAvatarStudioEnabled && import.meta.env.VITE_FEATURE_AVATAR_STUDIO_ENABLED === 'true')) return null;
  return (
    <p role="note" data-testid="avviso-sfondo-tolto" className="flex items-start gap-1.5 text-xs font-semibold text-amber-400">
      <Info aria-hidden className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>{t('common.backgroundRemoved')}</span>
    </p>
  );
}
